<template lang="pug">
button-base.button-next.font-bold(@click='clickEvent')
  slot
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'

/**
 * 次へボタン
 */
@Component({
  components: {
    ButtonBase,
  },
})
export default class ButtonNext extends Vue {
  private clickEvent(key: Event): void {
    this.$emit('click', key)
  }
}
</script>

<style lang="stylus" scoped>
.button-next
  height var(--input-height-default)
  padding 10px
  color var(--color-input-next__text)
  background-color var(--color-input-next__background)
  border-radius 20px
</style>
